<template>
  <component :is="tag" class="mx-auto w-full max-w-screen-3xl px-6 md:px-10">
    <slot />
  </component>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    tag?: keyof HTMLElementTagNameMap;
  }>(),
  {
    tag: "div",
  },
);
</script>
